import { formatLensValueNumber, parseLensValueString } from "./lensValueParser";

const BLANK_VALUE_TEXT = "Em branco";

export const sumLensValues = (value1, value2) => {
  const parsedValue1 = parseLensValueString(value1);
  const parsedValue2 = parseLensValueString(value2);

  const result = parsedValue1 + parsedValue2;

  if (isNaN(result)) return BLANK_VALUE_TEXT;

  return formatLensValueNumber(result);
};
